export default ({ fileSize, uploadStatus }) => {
  const trackersToUse = window.trackersToUse || '';
  const fileSizeInKB = fileSize / 1024;

  if (!window.snowplow) {
    return;
  }

  window.snowplow(`trackSelfDescribingEvent${trackersToUse}`, {
    event: {
      schema: `iglu:com.snowplowanalytics.iglu/anything-a/jsonschema/1-0-0`,
      data: {
        event_name: 'source_material_upload',
        size_in_kb: fileSizeInKB,
        upload_status: uploadStatus,
      },
    },
  });
};
